import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

/**
 * returns a formatted version of a currency key ("USD / EUR" for "USD_EUR")
 */
export const formatCurrencyKey = (key) => key ? key.replace('_', ' / ') : null;

/**
 * Creates a link to the currency pair details based on the `currencyPair` identifier
 * When passing in children the default rendering will be replaced by the given children.
 */

 
const CurrencyPairLink = (props) => {
  let currencyPair = props.currencyPair;
  const { onClick } = props;
  if (props.invertPair) {
    const currencyPairArray = currencyPair.split('_');
    currencyPair = currencyPairArray[1] + '_' + currencyPairArray[0];
  }
 
  const to = `/currency-details?currencyPair=${currencyPair}`;
 
  if (props.children) {
    return <Link to={to} onClick={onClick}>{props.children}</Link>;
  }
 
  return (
    <Link to={to}>
      {formatCurrencyKey(currencyPair)}
      {props.labelAddition}
    </Link>
  );
};
 

CurrencyPairLink.propTypes = {
    currencyPair: PropTypes.string.isRequired,
    labelAddition: PropTypes.node,

    //  creates a link for the inverted currency pair
    invertPair: PropTypes.bool,

    // if true renders the children
    isWrapper: PropTypes.bool
};

export default CurrencyPairLink;